import React, { memo, useRef } from 'react';
import { Button } from '~/UIKit';
import { useLanguage } from '~/Hooks';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { FilterBadge, FilterModal } from '~/Components/Filter';

export interface IFilterBaseProps {
  open: boolean;
  onClear: () => void;
  onClose: () => void;
  onApply: () => void;
  children: JSX.Element;
}

export interface IFilter extends IFilterBaseProps {
  onOpen: () => void;
  selectedCount: number;
}

export const Filter = memo(({ open, children, selectedCount, onOpen, ...props }: IFilter) => {
  const { t } = useLanguage();
  const filterButton = useRef(null);

  return (
    <>
      <Button
        ref={filterButton}
        size="small"
        onClick={onOpen}
        variant="outlined"
        startIcon={selectedCount ? <FilterAltIcon /> : <FilterAltOutlinedIcon />}
      >
        <FilterBadge badgeContent={selectedCount}>{t('app.filter')}</FilterBadge>
      </Button>
      <FilterModal
        {...props}
        open={!!filterButton.current && open}
        anchorEl={filterButton.current}
        selectedCount={selectedCount}
      >
        {children}
      </FilterModal>
    </>
  );
});
